import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../Contexts/AuthContext';
import Document_Schedule_Details from '../Document_Schedule_Details';


export default function Panel_ScheduleManagement_Manager_Center() {
    const { Account, Loading, Logout } = useAuth();

    if (Loading) {
        return null;
    }



    return (

        <>
            <Document_Schedule_Details/>
        </>
    );
}
